import DOMPurify from "dompurify";

/**
 * Bereinigt angreiferkontrolliertes HTML (v. a. E-Mail-Bodies) vor dem Rendern via
 * `dangerouslySetInnerHTML`. Entfernt aktive Inhalte (Skripte, Event-Handler, iframes …),
 * behält aber passive E-Mail-Formatierung wie Tabellen. Links werden als Text
 * dargestellt, damit eingehende Nachrichten keine klickbaren Spam-Ziele enthalten.
 * Security-Audit H2 (Stored XSS über E-Mail-HTML).
 */
export function sanitizeEmailHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html ?? "", {
    // Aktive Inhalte und externe Bildressourcen vollständig entfernen.
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "base", "link", "meta", "img", "a"],
    // Keine Remote-Ressourcen aus E-Mails laden: Bilder, CSS-URLs und srcset könnten Öffnungen tracken.
    FORBID_ATTR: ["style", "background", "bgcolor", "color", "srcset", "href"],
  });
}
